import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  bottom: 0;
  width: 100%;
`;

export const InnerContainer = styled.div`
  background-color: #f5f5f5;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 575px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 768px) {
    justify-content: space-evenly;
  }
`;

export const MainContainer = styled.div`
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  gap: 60px;
  @media (max-width: 575px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
  align-items: center;
  align-items: center;
  margin-top: 108px;
`;
export const MiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
  align-items: center;
  justify-content: center;
  margin-top: 108px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25%;
  align-items: center;
  margin-top: 108px;
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 12px;
`;

export const Heading = styled.h3`
  font-size: 43px;
  color: #f08700;
  font-family: Poppins-Medium;
`;

export const Text = styled.p`
  font-size: 36px;
  font-family: Poppins-ExtraLight;
  color: #0f1a20;
`;
export const Description = styled.p`
  font-size: 24px;
  color: #1d1d1d;
  font-family: Poppins-ExtraLight;
  margin-bottom: 16px;
`;
export const NumberContainer = styled.p`
  font-size: 26px;
  font-family: Poppins-Medium;
  color: #1d1d1d;
  padding-right: 40px;
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: initial;
  gap: 16px;
`;

export const Icon = styled.img`
  width: 28.42px;
  height: 28.25px;
  margin-top: 7px;
`;

export const Heading2 = styled.h3`
  font-size: 36px;
  font-family: Poppins-Light;
  color: #f08700;
  padding-left: 12px;
`;

export const SubHeading = styled.h6`
  font-size: 24px;
  font-family: Poppins-ExtraLight;
  color: #1d1d1d !important;
  align-items: left;
  :hover {
    cursor: pointer;
  }
  a {
    color: #1d1d1d !important;
  }
`;

export const MiddleBottomContainer = styled.div`
  align-items: left;
`;

export const Line = styled.div`
  border-left: 1px solid #000000;
  height: 390px;
  margin-top: 90px;
  @media (max-width: 575px) {
    display: none;
  }
`;
export const HorizontalLine = styled.div`
  border: 2px solid #000000;
  margin-left: -25px;
  margin-right: -25px;

  @media (max-width: 575px) {
    display: none;
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const LastContainer = styled.div`
  font-size: 22px;
  font-family: Poppins-ExtraLight;
  color: #1d1d1d;
  align-items: left;
  margin-left: 125px;
  margin-bottom: 15px;
`;

export const InnerContainer2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  grid-column-gap: 15px;
`;

export const InnerRightContainer = styled.div`
  display: inherit;
  flex-direction: column;
  gap: 15px;
`;

export const InnerLeftContainer = styled.div`
  display: inherit;
  flex-direction: column;
  gap: 15px;
`;

export const InnerContainer3 = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
`;
